module.exports = __webpack_public_path__ + "static/logo-black-bfad26b50ca1ae9450f685c1f55a1dba.png";